import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Contact from "./views/Contact.vue";
import Projects from "./views/Projects.vue";
import store from "@/store";
Vue.use(Router);

const router = new Router({
  mode: "history",
  linkExactActiveClass: "active-class",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      const position = {};
      if (to.hash) {
        position.selector = to.hash;
        if (to.hash === "#experience") {
          position.offset = { y: 140 };
        }
        if (document.querySelector(to.hash)) {
          return position;
        }

        return false;
      }
    }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      props: true,
    },
    {
      path: "/about",
      name: "about",
      component: About,
      props: true,
    },
    {
      path: "/projects",
      name: "projects",
      component: Projects,
      props: true,
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
      props: true,
    },

    {
      path: "/project/:slug",
      name: "ProjectDetails",
      props: true,
      component: () => import("./views/ProjectDetails.vue"),
      beforeEnter: (to, from, next) => {
        const exists = store.projects.find(
          (project) => project.slug === to.params.slug
        );
        if (exists) {
          next();
        } else {
          next({ name: "notFound" });
        }
      },
    },
    {
      path: "/404",
      alias: "*",
      name: "notFound",
      component: () =>
        import(/* webpackChunkName: "NotFound" */ "./views/NotFound"),
    },
  ],
});

export default router;
